import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  inject,
  signal,
  viewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error',
  standalone: true,
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorComponent implements OnInit {
  readonly #route = inject(ActivatedRoute);
  readonly #renderer = inject(Renderer2);

  readonly errorContainer =
    viewChild<ElementRef<HTMLElement>>('errorContainer');

  readonly errorType = this.#route.snapshot.queryParamMap.get('errorType');

  readonly hasError = signal(false);

  ngOnInit(): void {
    void this.loadTemplate();
  }

  private async loadTemplate(): Promise<void> {
    try {
      const response = await fetch(
        `/assets/error-pages/${this.errorType}.html`
      );

      if (!response.ok) {
        throw new Error();
      }

      const html = await response.text();
      this.processTemplate(html);
    } catch {
      this.hasError.set(true);
    }
  }

  private processTemplate(html: string): void {
    const container = this.errorContainer()?.nativeElement;
    if (!container) {
      return;
    }

    const div = this.#renderer.createElement('div') as HTMLElement;
    this.#renderer.setProperty(div, 'innerHTML', html);
    this.#renderer.appendChild(container, div);
  }
}
